import { T } from '@/i18n';
import { Button } from '@/ui';

type Read = { data: unknown; isError: boolean; refetch: () => unknown };
/** A successful empty response is known. A missing or failed response never implies zero. */
export function ReadNotice({ reads }: { reads: [string, Read][] }) {
  const failed = reads.filter(([, q]) => q.isError);
  const missing = reads.filter(([, q]) => q.data === undefined);
  if (!failed.length && !missing.length) return null;
  return (
    <div className={`oxread${failed.length ? ' oxread-error' : ''}`} aria-live="polite">
      <span>
        {failed.length
          ? `${T('Kunne ikke oppdatere')} ${failed.map(([name]) => T(name)).join(', ')}. ${T('Tall og forslag er ikke bekreftet.')}`
          : `${T('Henter')} ${missing.map(([name]) => T(name)).join(', ')}…`}
      </span>
      {failed.length > 0 && (
        <Button
          small
          onClick={() => {
            for (const [, q] of failed) void q.refetch();
          }}
        >
          {T('Prøv igjen')}
        </Button>
      )}
    </div>
  );
}
